<form [formGroup]="form" autoTrackUnsavedChanges>
  <div class="tab-panel-content-wrapper">
    @if (options?.length) {
      <div class="service-categories-grid">
        <div class="service-category-column">
          @for (opt of leftOptions; track opt.value) {
            <div class="tab-panel-input-wrapper service-category-item">
              <label class="field-input-label tab-input-label">{{ opt.label }}</label>
              <p-toggleswitch
                [ngModel]="isSelected(opt.value)"
                [ngModelOptions]="{ standalone: true }"
                (onChange)="toggleCategory(opt.value, $event.checked)"
              ></p-toggleswitch>
            </div>
          }
        </div>

        <div class="service-category-column">
          @for (opt of centerOptions; track opt.value) {
            <div class="tab-panel-input-wrapper service-category-item">
              <label class="field-input-label tab-input-label">{{ opt.label }}</label>
              <p-toggleswitch
                [ngModel]="isSelected(opt.value)"
                [ngModelOptions]="{ standalone: true }"
                (onChange)="toggleCategory(opt.value, $event.checked)"
              ></p-toggleswitch>
            </div>
          }
        </div>

        <div class="service-category-column">
          @for (opt of rightOptions; track opt.value) {
            <div class="tab-panel-input-wrapper service-category-item">
              <label class="field-input-label tab-input-label">{{ opt.label }}</label>
              <p-toggleswitch
                [ngModel]="isSelected(opt.value)"
                [ngModelOptions]="{ standalone: true }"
                (onChange)="toggleCategory(opt.value, $event.checked)"
              ></p-toggleswitch>
            </div>
          }
        </div>
      </div>
    } @else {
      <div class="tab-panel-input-wrapper">
        <span>No service categories available.</span>
      </div>
    }

  </div>
</form>
